// extracted by mini-css-extract-plugin
module.exports = {"root":"az_a5b","icon":"az_b5b"};